export default __webpack_public_path__ + "static/media/counter.a43549b6.gif";